import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
import React, { useState, useEffect } from "react";
// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";
import { useMutation, useQuery } from "@apollo/client";
//import { useParams } from "react-router-dom";
import { ALL_PROPOSALS, DELETE_PROPOSAL, LOCK_PROPOSAL } from "../queries";
import { Button } from "@mui/material";
//import DesignBlocks from "pages/Presentation/proposals/DesignBlocks";
//import Pages from "pages/Presentation/proposals/Pages";
//import Testimonials from "pages/Presentation/proposals/Testimonials";
//import Download from "pages/Presentation/proposals/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Images
import bgImage from "assets/images/strategia.jpg";
import { useTranslation } from "react-i18next";
/* eslint-disable react/prop-types */
const Proposalsadmin = ({ setError }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  const [proposals, setProposals] = useState([]);
  const [t] = useTranslation("common");
  const proposalss = useQuery(ALL_PROPOSALS, {
    pollInterval: 1000000,
  });
  useEffect(() => {
    let proposalsss = [];
    //let municipalitiess = [];
    if (proposalss.data) {
      proposalsss = proposalss.data.allProposals;
      //setOrgans(organss);
      //console.log(proposalsss);
      setProposals(proposalsss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [proposalss]);
  const [lockProposal] = useMutation(LOCK_PROPOSAL, {
    refetchQueries: [{ query: ALL_PROPOSALS }],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      //setError(error.graphQLErrors[0].message)
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addproposal)
    }*/
  });

  const [deleteProposal] = useMutation(DELETE_PROPOSAL, {
    refetchQueries: [{ query: ALL_PROPOSALS }],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      //setError(error.graphQLErrors[0].message)
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addproposal)
    }*/
  });
  const setLocked = async (event) => {
    //event.preventDefault()
    ////console.log(event)
    lockProposal({
      variables: { id: event, active: false },
    });
    //muutetaan activated !actived edituser
  };
  const setUnlocked = async (event) => {
    //event.preventDefault()
    ////console.log(event)
    lockProposal({
      variables: { id: event, active: true },
    });
    //muutetaan activated !actived edituser
  };

  const setDelete = async (event) => {
    //event.preventDefault()
    ////console.log(event)
    deleteProposal({
      variables: { id: event },
    });
    //muutetaan activated !actived edituser
  };

  return (
    <>
      <MKBox
        minHeight="23vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "2500px 500px",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      />
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="black"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Päätösehdotus Admin{" "}
            </MKTypography>
            <MKTypography
              variant="body1"
              color="black"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              {proposals.map((prop) => (
                <>
                  {prop.proposaltext}
                  <br />
                  <Button
                    style={{
                      backgroundColor: "#07575B",
                      color: "#C4DFE6",
                      fontSize: "14px",
                    }}
                    size="small"
                    type="submit"
                    onClick={() => setUnlocked(prop.id)}
                  >
                    {t("common.unlock")}
                  </Button>
                  <Button
                    style={{
                      backgroundColor: "#07575B",
                      color: "#C4DFE6",
                      fontSize: "14px",
                    }}
                    size="small"
                    type="submit"
                    onClick={() => setLocked(prop.id)}
                  >
                    {t("common.lock")}
                  </Button>
                  <Button
                    style={{
                      backgroundColor: "#07575B",
                      color: "#C4DFE6",
                      fontSize: "14px",
                    }}
                    size="small"
                    type="submit"
                    onClick={() => {
                      if (window.confirm("Haluatko varmasti poistaa aloitteen?")) {
                        setDelete(prop.id);
                      }
                    }}
                  >
                    {t("common.delete")}
                  </Button>
                  <br />
                </>
              ))}
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
    </>
  );
};

export default Proposalsadmin;
